import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { IconsModule } from '../../design/icons.module';

import { LoadingContentModule } from '../../directives/loading-content/loading-content.module';
import { PaginationModule } from '../pagination/pagination.module';
import { TableExportModule } from '../table-export/table-export.module';
import { DataTableComponent } from './data-table.component';
import { TrustedHtmlPipe } from './trusted-html.pipe';

@NgModule({
  declarations: [DataTableComponent, TrustedHtmlPipe],
  imports: [CommonModule, TableModule, PaginationModule, LoadingContentModule, IconsModule, TableExportModule],
  exports: [DataTableComponent, TrustedHtmlPipe]
})
export class DataTableModule { }
